import Statusbar from '../../Statusbar';
import showNotificationCentered from '../../utils/showNotificationCentered';

export default function textExecutor({ title = '', subtitle = '', duration = 10 }, done) {
	log(`Notifications.doText "${title}" ("${subtitle}") for ${duration}s`);

	Statusbar.addStatus({ title, subtitle });

	const el = $(`<div class="notification-text">
			<h1>${title}</h1>
			<p>${subtitle}</p>
	</div>`);

	return showNotificationCentered(el, duration, done);
}
